import { useQuery } from '@tanstack/react-query'
import axAPI from 'httpConfig'
import { GroupsStatusTabs, IGroupEntity } from 'models'

export const useGetGroups = ({
	statuses,
	barns,
	foodtableOnly,
	enabled = true,
}: {
	statuses?: GroupsStatusTabs[]
	barns?: string
	foodtableOnly?: boolean
	enabled?: boolean
} = {}) => {
	const { data, refetch, isError, isLoading } = useQuery({
		queryKey: ['groupsList', statuses?.join(','), barns, foodtableOnly],
		queryFn: async () => {
			const response = await axAPI.get<unknown>('/groups/list', {
				params: {
					...(statuses?.length && { status: statuses.join(',') }),
					barns,
					...(foodtableOnly && { foodtable_only: true }),
				},
			})
			return (response as { data: IGroupEntity[] }).data
		},
		enabled,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
